<template>
  <div class="page-with-top-bar">
    <project-admin-quick-buttons hiddenOption="storehouse" />
    <section>
      <div class="mt-4">
        <b-tabs type="is-boxed" v-model="mainActiveTab">
          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="boxes"></b-icon>
              <span> {{ $t('materials') }} </span>
            </template>
            <warehouse-materials :project-id="project_id" />
          </b-tab-item>
          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="truck"></b-icon>
              <span> {{ $t('providers') }} </span>
            </template>
            <warehouse-providers :project-id="project_id" />
          </b-tab-item>
          <b-tab-item>
            <template #header>
              <b-icon pack="fas" icon="sliders-h"></b-icon>
              <span> {{ $t('fields_configuration') }} </span>
            </template>
            <manage-extrafields :project-id="project_id" />
          </b-tab-item>
        </b-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectAdminQuickButtons from '·/components/project-admin-quick-buttons'
import WarehouseMaterials from './warehouse/warehouse-materials.vue'
import WarehouseProviders from './warehouse/warehouse-providers.vue'
import ManageExtrafields from '../../components/storehouse/manage-extrafields.vue'

export default {
  name: 'admin-project-warehouse',
  middleware: 'auth',
  title: 'storehouse',
  menuOption: '0-2',
  components: {
    ProjectAdminQuickButtons,
    WarehouseMaterials,
    WarehouseProviders,
    ManageExtrafields,
  },
  computed: {
    ...mapGetters({
      navData: 'app/navData',
      project: 'app/project',
    }),
  },
  data: () => ({
    project_id: null,
    mainActiveTab: 0,
  }),
  created() {
    this.$options.subtitle = ['project_actions_page_subtitle', [this.navData.project_name.toUpperCase()]]
    this.project_id = this.navData.project_id

    // Si no está activado Warehouse v2, volvemos al almacén clásico.
    if (Number(this.project && this.project.warehouse_type) !== 1) {
      this.$router.replace({ name: 'project.admin.storehouse', params: { project_id: this.project_id } })
      return
    }

  },
}
</script>

